import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ProfileOptionsComponent } from '../profile-options/profile-options.component';
// import { NotificationsComponent } from '../notifications/notifications.component';

@Component({
  selector: 'app-navbar',
  imports: [
    CommonModule,
    ProfileOptionsComponent,
    // NotificationsComponent
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
  private readonly limitWidth: number = 1024;

  @Input() showSidebar: boolean = window.innerWidth > this.limitWidth;
  @Output() private readonly showSidebarChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  toggleNavbarMobile: boolean = false;

  toggleMenu(): void {
    this.showSidebar = !this.showSidebar;
    this.showSidebarChange.emit(this.showSidebar);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.showSidebar = window.innerWidth > this.limitWidth;
    this.showSidebarChange.emit(this.showSidebar);
  }
}
